import React, { Component } from "react";
import styled from "styled-components";
import { Scrollbars } from "react-custom-scrollbars";
import { WidgetWrapper, WidgetMember3 } from "./components/Widget";
import CaseAndCustomer from "./CaseAndCustomer";
import ResponseRateSummary from "./ResponseRateSummary";
import ResponseTimeAndHandlingTimeSummary from "./ResponseTimeAndHandlingTimeSummary";
import PeakTimeSummary from "./PeakTimeSummary";
import ResponseRatePanel from "./ResponseRatePanel";
import RespondedCountPanel from "./RespondedCountPanel";
import ResponseTimePanel from "./ResponseTimePanel";
import HandlingTimePanel from "./HandlingTimePanel";
import WordCloud from "./WordCloud";
import Category from "./Category";
import Filter from "./Filter";
import Modal from "module-common/DownloadModal";
import Button from "module-common/Button";

export default class Analytics extends Component {
  state = { showCloseModal: false };
  render() {
    const { showCloseModal, reportDateStart, reportDateEnd } = this.state;

    return (
      <Scrollbars>
        <Wrapper>
          <BackgroundWhite>
            <ReportWrapper>
              <Report>Report</Report>
              <StyledButton color="blue" size="large" onClick={this.showModal}>
                Download
              </StyledButton>
              {showCloseModal && (
                <Modal
                  text="Send Analytic Report to Email"
                  onCancel={this.hideModal}
                  onConfirm={this.hideModal}
                />
              )}
            </ReportWrapper>
            <Filter />
          </BackgroundWhite>
          <Header>
            <CaseAndCustomer />
            <ResponseRateSummary />
            <ResponseTimeAndHandlingTimeSummary />
            <PeakTimeSummary />
          </Header>

          <RespondedCountPanel />      
          <ResponseRatePanel />
          <ResponseTimePanel />
          <HandlingTimePanel />

          <InlineWidgetWrapper2>
            <WidgetMember3>
              <WidgetWrapper>
                <WordCloud />
              </WidgetWrapper>
            </WidgetMember3>
            <WidgetMember3>
              <WidgetWrapper>
                <Category />
              </WidgetWrapper>
            </WidgetMember3>
          </InlineWidgetWrapper2>
        </Wrapper>
      </Scrollbars>
    );
  }

  showModal = () => {
    this.setState({ showCloseModal: true });
  };

  hideModal = () => {
    this.setState({ showCloseModal: false });
  };
}

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #ebeef7;
  margin-right: 2px;
`;

const Header = styled.section`
  display: flex;
  flex: none;
  flex-direction: row;
  height: 220px;
  background-color: #ebeef7;
  justify-content: center;
  align-items: center;
  color: white;
`;

const Report = styled.span`
  text-transform: uppercase;
  font-size: 20px;
  font-weight: bold;
  color: #21445a;
  background: white;
  display: flex;
`;

const InlineWidgetWrapper2 = styled.section`
  flex-direction: row;
  display: flex;
  flex: none;
  justify-content: space-between;
  padding: 0;
`;

const BackgroundWhite = styled.section`
  background: white;
  border: solid 2px #cfd0d5;
  border-radius: 5px;
  margin: 10px;
`;

const StyledButton = styled(Button)`
  display: flex;
`;

const ReportWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #f1f3f9;
  padding: 5px 15px;
`;



// WEBPACK FOOTER //
// ./src/module-analytics/index.js